import UnlimitedCardsImage from 'assets/images/tickets/unlimited-cards.png'
import UnlimitedCardsImage2x from 'assets/images/tickets/unlimited-cards@2x.png'
import UnlimitedCardsImage3x from 'assets/images/tickets/unlimited-cards@3x.png'
import Box from 'components/shared/Box'
import Button from 'components/shared/Button'
import HeaderDecor from 'components/shared/HeaderDecor'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import { UNLIMITED_LANDING_PAGE } from 'constants/links'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { UnlimitedCtaBox, UnlimitedCtaTop } from './styles'

const UnlimitedCta = () => {
    const { isTablet } = useResolutions()

    return (
        <UnlimitedCtaBox
            mt={[16, 74]}
            padding={[16, 0]}
            pt={[16, 34]}
            pb={[16, 34]}
        >
            <UnlimitedCtaTop>
                <img
                    src={UnlimitedCardsImage}
                    srcSet={`${UnlimitedCardsImage2x} 2x,
                    ${UnlimitedCardsImage3x} 3x
                    `}
                    alt=""
                />

                <HeaderDecor
                    color="grayscale_0"
                    variant="heading4"
                    mt={[0, 30]}
                >
                    <FormattedMessage
                        id="global.unlimitedcta.title"
                        defaultMessage="Karta Unlimited"
                    />
                </HeaderDecor>
            </UnlimitedCtaTop>
            <Box pl={[0, 20]} pr={[0, 20]} pt={[12, 16]}>
                <Text color="grayscale_400" variant="bodySmall" mb={[0, 16]}>
                    <FormattedMessage
                        id="global.unlimitedcta.description"
                        defaultMessage="Zapłać raz, korzystaj przez cały rok. Już od <span>649 zł</span>!"
                        values={{
                            span: (chunks: string[]) => (
                                <>
                                    <Text
                                        as="span"
                                        variant="bodySmall"
                                        color="grayscale_0"
                                    >
                                        {chunks}
                                    </Text>
                                </>
                            ),
                        }}
                    />
                </Text>
                {!isTablet ? (
                    <Button
                        href={UNLIMITED_LANDING_PAGE}
                        variant="borderPrimary"
                        width="100%"
                        target="_blank"
                        rel="noreferrer"
                        testId="step-info-redirect-unlimited-landing"
                    >
                        <FormattedMessage
                            id="global.unlimitedcta.title"
                            defaultMessage="Karta Unlimited"
                        />
                    </Button>
                ) : (
                    <a
                        href={UNLIMITED_LANDING_PAGE}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Icon variant="arrow" color="primary_500" />
                    </a>
                )}
            </Box>
        </UnlimitedCtaBox>
    )
}

export default UnlimitedCta
